<ng-container *transloco="let t">
  <form class="step" (submit)="validateStepAndContinue($event)" novalidate>
    <dx-validation-group #validationGroup>
      <section class="two-columns">
        <pxw-text-field
          [label]="t('information.name')"
          [placeholder]="t('information.name')"
          [(value)]="registrationSharedService.registrationData.customer.firstName"
          [rules]="[{ type: 'required', message: t('information.nameRequired') }]"
          stylingMode="underlined"
        ></pxw-text-field>
        <pxw-text-field
          [label]="t('information.lastName')"
          [placeholder]="t('information.lastName')"
          [(value)]="registrationSharedService.registrationData.customer.lastName"
          [rules]="[{ type: 'required', message: t('information.lastNameRequired') }]"
          stylingMode="underlined"
        ></pxw-text-field>
      </section>
      <pxw-text-field
        [label]="t('information.email')"
        [placeholder]="t('information.email')"
        mode="email"
        [(value)]="registrationSharedService.registrationData.customer.email"
        (valueChange)="onEmailChanged($event)"
        [rules]="[
          { type: 'required', message: t('information.emailRequired') },
          { type: 'pattern', pattern: emailPattern, message: t('information.emailInvalid') }
        ]"
        stylingMode="underlined"
      ></pxw-text-field>
      <pxw-cellphone
        [label]="t('information.phone')"
        [(value)]="registrationSharedService.registrationData.customer.phone"
        [invalidMessage]="t('information.phoneInvalid')"
        [placeholder]="t('information.phonePlaceholder')"
        [disabledCountryCode]="true"
        [countrySelected]="countrySelected"
        [required]="true"
        stylingMode="underlined"
      ></pxw-cellphone>
      <div class="ui-input discovery-sources__container">
        <label style="margin: 0; margin-bottom: 0.5em" class="ui-label">{{
          t('information.discoverySource')
        }}</label>
        <dx-select-box
          [dataSource]="discoverySources"
          displayExpr="value"
          valueExpr="key"
          [placeholder]="t('information.discoverySource')"
          [(value)]="registrationSharedService.registrationData.customer.discoverySource"
          stylingMode="outlined"
          validationMessageMode="always"
        >
          <dx-validator>
            <dxi-validation-rule
              type="required"
              [message]="t('information.discoverySourceRequired')"
            ></dxi-validation-rule>
          </dx-validator>
        </dx-select-box>
      </div>
    </dx-validation-group>
    <div class="button-wrapper">
      <pxw-button display="block" type="warning" size="md" (click)="prev()">
        <i class="ci-short_left"></i>
        {{ t('general.back') }}
      </pxw-button>
      <pxw-button mode="submit" display="block" type="warning" size="md">{{
        t('general.next')
      }}</pxw-button>
    </div>
  </form>
</ng-container>
